import React from 'react';
import { useFormContext } from 'react-hook-form';
import ControlledDateInput from '@/components/common/form/ControlledDateInput';
import translate from '@/lib/intl/translate';
import type CustomField from '@/types/api/CustomField';

function CustomFieldDate({
  error,
  ...field
}: CustomField & { error?: boolean }) {
  const { control, formState } = useFormContext();
  const { customFieldId, fieldName, isRequired } = field;

  return (
    <ControlledDateInput
      control={control}
      error={error}
      helperText={
        formState.errors?.customFields?.[customFieldId]?.message as
          | string
          | undefined
      }
      label={fieldName}
      name={`customFields.${customFieldId}`}
      required={!!isRequired}
      rules={
        isRequired ? { required: translate('FORMS_VALIDATION_REQUIRED') } : {}
      }
    />
  );
}

export default CustomFieldDate;
